/** Diff de linhas simples (LCS) para patches before/after. */
export function buildUnifiedDiffLines(before, after) {
    const a = String(before ?? "").split("\n");
    const b = String(after ?? "").split("\n");
    const n = a.length;
    const m = b.length;
    const dp = Array.from({ length: n + 1 }, () => Array(m + 1).fill(0));
    for (let i = n - 1; i >= 0; i -= 1) {
        for (let j = m - 1; j >= 0; j -= 1) {
            if (a[i] === b[j]) dp[i][j] = dp[i + 1][j + 1] + 1;
            else dp[i][j] = Math.max(dp[i + 1][j], dp[i][j + 1]);
        }
    }

    const lines = [];
    let i = 0;
    let j = 0;
    while (i < n && j < m) {
        if (a[i] === b[j]) {
            lines.push({ type: "context", text: a[i] });
            i += 1;
            j += 1;
        } else if (dp[i + 1][j] >= dp[i][j + 1]) {
            lines.push({ type: "del", text: a[i] });
            i += 1;
        } else {
            lines.push({ type: "add", text: b[j] });
            j += 1;
        }
    }
    while (i < n) {
        lines.push({ type: "del", text: a[i] });
        i += 1;
    }
    while (j < m) {
        lines.push({ type: "add", text: b[j] });
        j += 1;
    }
    return lines;
}

const lineClass = {
    context: "text-gray-300",
    del: "bg-red-950/50 text-red-200",
    add: "bg-emerald-950/40 text-emerald-200",
};

const linePrefix = {
    context: " ",
    del: "-",
    add: "+",
};

export default function BotOpsConfigDiff({ before, after }) {
    const lines = buildUnifiedDiffLines(before, after);
    return (
        <pre
            className="text-xs font-mono whitespace-pre-wrap break-words rounded-md border border-[#b47c06]/30 bg-black/50 p-3 overflow-x-auto"
            data-testid="bot-ops-config-diff"
        >
            {lines.map((line, idx) => (
                <div key={idx} className={lineClass[line.type] || lineClass.context}>
                    <span className="select-none opacity-70 mr-2">{linePrefix[line.type]}</span>
                    {line.text}
                </div>
            ))}
        </pre>
    );
}
